import { createDashboardReduxModule } from 'utils/reduxDashboardModuleCreator'

export const phishingWidgetRedux = createDashboardReduxModule({
  name: 'PHISHING_WIDGET',
  path: 'dashboard/home/phishingWidget',
})
